let Suggestions = function (searches, shops, query) {
    this.searches = searches || [];
    this.shops = shops || [];
    this.query = query || '';
};

module.exports = Suggestions;


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/models/suggestions.js